<template>
    <TagSetting :referenceType="'Tags - Case Info'"/>
</template>
<script>
    const TagSetting = () => import("./list.vue")
    export default {
        name: 'case-setting-info-tags',
        components: {
            TagSetting
        },
        data () {
            return {}
        },
        methods:{}
    }
</script>
